import router, {resetRouter} from './router'
import store from './store'
import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken, setToken} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/meet-sign', '/success-result', '/code-download', '/upload-submission', '/upload-sign-image', '/user-sign', '/memo-check-unit', '/memo-rep', '/upload-enterprise-memo'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = Object.keys(store.getters.userInfo).length > 0
      if (hasRoles) {
        next()
      } else {
        next()
        // try {
        //   store.dispatch('user/getInfo').then(() => {
        //     store.dispatch('permission/generateRoutes').then(() => {
        //       resetRouter()
        //       const accessRoutes = store.getters.permission_addRoutes
        //       router.addRoutes(accessRoutes)
        //       next({ ...to, replace: true })
        //     })
        //   }).catch(() => {
        //     Message.error({ message: '请求用户信息失败，请重试' })
        //     // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
        //     store.dispatch('user/logout').then(() => {
        //       next(`/login?redirect=${to.path}`)
        //     })
        //     NProgress.done()
        //   })
        // } catch (error) {
        //   // remove token and go to login page to re-login
        //   await store.dispatch('user/resetToken')
        //   Message.error(error || 'Has Error')
        //   next(`/login?redirect=${to.path}`)
        //   NProgress.done()
        // }
      }
    }
  } else {
    // 如果路径上有token就获取存到本地储存里去
    // 1、然后在刷新页面让url地址栏清空
    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')
    console.log('执行了我保存了token', urlParams, token)
    if (token) {
      // commit('SET_TOKEN', token)
      setToken(token)

      // next('/index')
      return window.location.replace(window.location.href = '/')
      // return   next('/index')
    }

    if (whiteList.includes(to.path)) {
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
